import { fromJS, Map } from 'immutable';

export function error(state) {
    window['al' + 'ert']('Cannot remove payment method');

    return state;
}
